import { render, staticRenderFns } from "./miscellaneous-certification.component.vue?vue&type=template&id=0b4862f1&scoped=true"
import script from "./miscellaneous-certification.component.ts?vue&type=script&lang=ts&external"
export * from "./miscellaneous-certification.component.ts?vue&type=script&lang=ts&external"
import style0 from "./miscellaneous-certification.component.vue?vue&type=style&index=0&id=0b4862f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4862f1",
  null
  
)

export default component.exports